import { useMemo } from 'react';
import { useFeature } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_KEYS } from '../../../config/growthbook';
import { parseAllowedAgentIds } from '../utils/ask-moo-access';

/**
 * The chat panel's agent allow-list from the `limit_moo_agents` flag, or
 * `null` when the flag isn't limiting anything (see `parseAllowedAgentIds`).
 *
 * Memoized on the ids' *contents*, not on the flag payload's object identity:
 * the result feeds `MooChatConfig.allowedAgentIds`, which `useAgentsCatalog`
 * reads inside the effect that seeds the shell catalog. A fresh array every
 * render would make that effect re-dispatch on every render.
 */
export function useAllowedAgentIds(): readonly string[] | null {
  const { value } = useFeature(FEATURE_FLAG_KEYS.LIMIT_MOO_AGENTS);
  const ids = parseAllowedAgentIds(value);
  const key = ids === null ? null : JSON.stringify(ids);
  return useMemo(
    () => (key === null ? null : (JSON.parse(key) as string[])),
    [key]
  );
}
